import { PLACEHOLDER_IMAGE_URL } from '../constants';

const enum IntegrationServiceEnum {
    PROM = 'prom',
    KASTA = 'kasta',
    HOROSHOP = 'horoshop',
    SHOP_EXPRESS = 'shop-express',
    ROZETKA = 'rozetka',
    EPICENTR = 'epicentr',
    WOOCOMMERCE = 'woocommerce',
    SHOPIFY = 'shopify',
    MAUDAU = 'maudau',
    EVA = 'eva',
    ALLO = 'allo',
    SUPPLIER = 'supplier'
}

function getServicesWhoNeedAdditionalRequest(): string[] {
    return [
        IntegrationServiceEnum.ROZETKA,
        IntegrationServiceEnum.EPICENTR,
        IntegrationServiceEnum.KASTA,
        IntegrationServiceEnum.MAUDAU,
    ]
}

function getIntegrationServiceLogo(value: string): string {
    switch (value) {
        case IntegrationServiceEnum.PROM:
            return '/img/logo/prom.png';
        case IntegrationServiceEnum.KASTA:
            return '/img/logo/kasta.png';
        case IntegrationServiceEnum.HOROSHOP:
            return '/img/logo/horoshop.png';
        case IntegrationServiceEnum.SHOP_EXPRESS:
            return '/img/logo/shop_express.png';
        case IntegrationServiceEnum.ROZETKA:
            return '/img/logo/rozetka.png';
        case IntegrationServiceEnum.EPICENTR:
            return '/img/logo/epicentr.png';
        case IntegrationServiceEnum.WOOCOMMERCE:
            return '/img/logo/woo_commerce.png';
        case IntegrationServiceEnum.SHOPIFY:
            return '/img/logo/shopify.png';
        case IntegrationServiceEnum.MAUDAU:
            return '/img/logo/maudau.png';
        case IntegrationServiceEnum.EVA:
            return '/img/logo/eva.png';
        default:
            return PLACEHOLDER_IMAGE_URL;
    }
}

export {
    IntegrationServiceEnum,
    getServicesWhoNeedAdditionalRequest,
    getIntegrationServiceLogo
}
